<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="mb-3">
    <h5 class="card-title placeholder-glow">
      <span class="placeholder col-7"></span>
    </h5>
    <p class="card-text placeholder-glow">
      <span class="placeholder me-2 col-8"></span>
      <span class="placeholder me-2 col-5"></span>
      <span class="placeholder me-2 col-6"></span>
      <span class="placeholder me-2 col-7"></span>
      <span class="placeholder me-2 col-9"></span>
      <span class="placeholder me-2 col-7"></span>
      <span class="placeholder me-2 col-9"></span>
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
